import React from "react";
import Meta from "../../components/Meta";
import JoinTeamSection from "../../components/Custom/JoinTeamSection";

function JoinTeamPage(props) {
  return (
    <>
      <Meta title="Join Team" />
      <JoinTeamSection />
    </>
  );
}

export default JoinTeamPage;
